export default {"src":"/_next/static/media/grundriss-schwarz.86354049.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};